<template>
    <div>
        <!-- Modal Component -->
        <b-modal v-model="openModal" title="New license" size="lg" ok-title="Save license" ok-variant="success" no-fade @hide="handleHide" @hidden="handleHidden" @ok="handleOk" ref="licenseModal" :ok-disabled="saving" :cancel-disabled="saving" :no-close-on-backdrop="true" scrollable>

            <div v-if="loading" class="text-center">
                <i class="fa fa-circle-o-notch fa-spin"></i> Loading
            </div>
            <template v-else>
                <div class="form-group row">
                    <label :class="{ 'col-md-3 col-form-label text-sm-right': true, 'text-danger': errors.license_id }">License:</label>
                    <div class="col-md-8">

                        <b-form-select v-model="license.license_id" :options="licenseOptions" :class="{'is-invalid': errors.license_id}"/>

                        <span v-if="errors.license_id" class="text-danger">
                            <span v-for="error in errors.license_id">{{ error }}</span>
                        </span>
                    </div>
                </div>

                <template v-if="enableOtherLicense">
                    <div class="form-group row">
                        <label class="col-md-3 col-form-label"></label>
                        <div class="col-md-8">
                            <b-form-checkbox v-model="is_other_license" :value="1" :unchecked-value="0" plain> Enter Other License</b-form-checkbox>

                            <span v-if="errors.is_other_license" class="text-danger">
                                <span v-for="error in errors.is_other_license">{{ error }}</span>
                            </span>
                        </div>
                    </div>

                    <div class="form-group row" v-if="is_other_license == 1">
                        <label :class="{ 'col-md-3 col-form-label text-sm-right': true, 'text-danger': errors.other_license_name }">Other License Name:</label>
                        <div class="col-md-8">

                            <b-form-input v-model="license.other_license_name" :class="{'is-invalid': errors.other_license_name}" placeholder="Enter Other License Name" />

                            <span v-if="errors.other_license_name" class="text-danger">
                                <span v-for="error in errors.other_license_name">{{ error }}</span>
                            </span>
                        </div>
                    </div>
                </template>

                <div class="form-group row">
                    <label :class="{ 'col-md-3 col-form-label text-sm-right': true, 'text-danger': errors.license_number }">License#:</label>
                    <div class="col-md-8">

                        <b-form-input type="text" v-model="license.license_number" :class="{'is-invalid': errors.license_number}" placeholder="Enter License#" />

                        <span v-if="errors.license_number" class="text-danger">
                            <span v-for="error in errors.license_number">{{ error }}</span>
                        </span>
                    </div>
                </div>

                <div class="form-group row">
                    <label :class="{ 'col-md-3 col-form-label text-sm-right': true, 'text-danger': errors.state_id }">State:</label>
                    <div class="col-md-8">

                        <select v-model="license.state_id" class="form-control" :class="{'is-invalid': errors.state_id}">
                            <option :value="null">-- Select a State --</option>
                            <option v-for="state in state_list" :value="state.state_id">{{ state.state_name }} ({{ state.state_code }})</option>
                        </select>

                        <span v-if="errors.state_id" class="text-danger">
                            <span v-for="error in errors.state_id">{{ error }}</span>
                        </span>
                    </div>
                </div>

                <div class="form-group row">
                    <label :class="{ 'col-md-4 col-form-label text-sm-right': true, 'text-danger': errors.file }">Copy of License:</label>
                    <div class="col-md-8">
                        <b-form-file v-model="file" plain></b-form-file>
                    </div>
                </div>
            </template>
        </b-modal>
    </div>
</template>

<script>
    export default {
        props: {

            subcontractorId: {
                type: Number,
                default: null,
            },

            enableOtherLicense: {
                type: Boolean,
                default: false,
            },
        },

        data: function() {
            return {
                openModal: false,
                loading: true,
                saving: false,
                is_other_license: 0,
                errors: {},
                file: null,
                licenses: [],
                license: {
                    state_id: null,
                    license_id: null,
                }
            }
        },

        computed: {
            state_list() {
                return this.$store.state.state_list;
            },

            licenseOptions(){
                //Setup
                var options = [{value: null, text: '-- Select a License --'}];

                //Build it
                for(var i = 0; i < this.licenses.length; i++)
                {
                    //Append
                    options.push({value: this.licenses[i].license_id, text: this.licenses[i].license_name});
                }

                //Send it
                return options;
            },
        },

        methods: {

            handleHide(bvEvt){

            },

            handleHidden(bvEvt){
                //Reset the values
                this.license = {};
                this.errors = {};
                this.file = null;
            },

            handleOk: function(bvEvt) {

               //Stops the modal from closing
               bvEvt.preventDefault();

               //Show loading?

               //Do it
               this.savelicense();
            },

            showModal(){
                //Show ti
                this.openModal = true;
            },

            setModel(license){
                //Set it
                this.license = JSON.parse(JSON.stringify(license));

                //Check it
                if(this.license.other_license_name)
                {
                    this.is_other_license = 1;
                }
            },

            getFormResources(){
                //Loading indicator
                this.loading = true;

                //Get the resources
                this.$http
                    .get('subcontractors/license')
                    .then(response => {
                        //Set it
                        this.licenses = response.data.licenses;

                        //Loading false
                        this.loading = false;
                    });
            },

            savelicense(){
                //Reset the errors
                this.errors = {};
                this.saving = true;

                //Set the helper
                this.license.enable_other_license = this.is_other_license;

                //Send it
                this.$http
                .postWithFiles('subcontractors/license/' + this.subcontractorId, this.license, (this.file ? [this.file] : []))
                .then(response => {
                    //Alert the user?
                    this.$toastr.success('License Saved');

                    //Update the STore
                    this.$store.commit('updateLicenses', response.data);

                    //Close the modal
                    this.$refs.licenseModal.hide();

                })
                .catch(error => {
                    //Check for error
                    if(error.response.status === 422)
                    {
                        //Display validation errors
                        this.errors = error.response.data
                    }
                })
                .then(response => {
                    //SHow loading
                    this.saving = false;
                });
            }
        },

        mounted() {
            //SEt the height
            //this.$refs.licenseModal.$refs.body.style['max-height'] = window.innerHeight * 0.75 + 'px';

            //Get the resources
            this.getFormResources();
        }
    }
</script>